export enum EstablishmentRight{
	ALL = 'ALL',
	BANK_ACCOUNT_READ = 'BANK_ACCOUNT_READ',
	BANK_ACCOUNT_UPDATE = 'BANK_ACCOUNT_UPDATE',
	TRANSACTION_READ = 'TRANSACTION_READ',
	TRANSACTION_VALIDATION = 'TRANSACTION_VALIDATION',
	TRANSACTION_UPDATE = 'TRANSACTION_UPDATE',
	TRANSACTION_INSERT = 'TRANSACTION_INSERT',
	UPLOAD_GET = 'UPLOAD_MANAGEMENT',
	UPLOAD_UPDATE = 'UPLOAD_UPDATE',
	INVOICE_SEQUENCE_UPDATE = 'INVOICE_SEQUENCE_UPDATE',
	INVOICE_TEMPLATE_UPDATE = 'INVOICE_TEMPLATE_UPDATE',
	INVOICE_MAIL_SEND = 'INVOICE_MAIL_SEND',
	INVOICE_READ = 'INVOICE_READ',
	INVOICE_UPDATE = 'INVOICE_UPDATE',
	STATS = 'STATS',
	EMPLOYEE_READ = 'EMPLOYEE_READ',
	EMPLOYEE_UPDATE = 'EMPLOYEE_UPDATE',
	CONTRACT_READ = 'CONTRACT_READ',
	CONTRACT_CREATE = 'CONTRACT_READ',
	CONTRACT_SIGN_AS_EMPLOYER = 'CONTRACT_SIGN_AS_EMPLOYER',
	PRODUCT_READ = 'PRODUCT_READ',
	PRODUCT_UPDATE = 'PRODUCT_UPDATE',
	INVENTORY_READ = 'INVENTORY_READ',
	INVENTORY_UPDATE = 'INVENTORY_UPDATE',
	INVENTORY_VALIDATE = 'INVENTORY_VALIDATE',
	TURNOVER_READ = 'TURNOVER_READ',
	TURNOVER_UPDATE = 'TURNOVER_UPDATE',
	GAIA_PRODUCTS_READ = 'GAIA_PRODUCTS_READ',
	GAIA_PRODUCTS_UPDATE = 'GAIA_PRODUCTS_UPDATE',
}